import { PostSelectBidView } from "@krea/customer-features/shared-components/post-select/PostSelectBidView";
import Preloader from "@krea/customer-features/shared-components/preloader";

import { useGetSelectedLenderResponse } from "store/current-loan-application/hooks/queries";
import {
  useMarkSigningUrlClicked,
  useMarkEligibleForPayment,
} from "store/lender-responses/hooks/mutations";

export const PostSelect = () => {
  const { data: selectedLenderResponse, isLoading } =
    useGetSelectedLenderResponse();
  const {
    mutate: setEligibleForPayment,
    isLoading: isMutatingEligibleForPayment,
  } = useMarkEligibleForPayment();
  const { mutate: setMarkSigningUrlClicked } = useMarkSigningUrlClicked();

  if (isLoading || !selectedLenderResponse) {
    return (
      <div className="tw-flex tw-min-h-[400px] tw-w-full tw-items-center tw-justify-center tw-bg-white">
        <Preloader className="tw-text-primary" size="xl" />
      </div>
    );
  }

  return (
    <PostSelectBidView
      selectedLenderResponse={selectedLenderResponse}
      setEligibleForPayment={(data) => {
        setEligibleForPayment(data);
      }}
      isMutatingEligibleForPayment={isMutatingEligibleForPayment}
      signingUrlSideEffect={(data) => {
        setMarkSigningUrlClicked(data);
      }}
    />
  );
};
